export default __webpack_public_path__ + "dd71f21a8cbc12eb2dfa75d97cfcfd31.png";